// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Services_mainContainer__ry5--","contBottom3":"Services_contBottom3__3GYop","servIcon":"Services_servIcon__25C68"};